"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckPtlDryvan = function SvgIconTruckPtlDryvan(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck ptl dryvan icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Ptl Dryvan Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.049 16.213H40l6 8.218v10.271h-4.002c0 3.398-2.686 6.16-6 6.16-3.315 0-5.999-2.762-5.999-6.16H18.001c0 3.398-2.689 6.16-6.002 6.16-3.313 0-6-2.762-6-6.16H2V12.108C2 9.832 3.789 8 6 8h22.957v20.717h2.092V16.213zm2.95 3.084v5.134h8.928L39 19.297h-5.001zm2 18.485c-1.659 0-3.001-1.383-3.001-3.08 0-1.706 1.342-3.08 3-3.08 1.657 0 3.002 1.374 3.002 3.08 0 1.697-1.345 3.08-3.001 3.08zm-27-3.08c0 1.697 1.343 3.08 3 3.08 1.654 0 3-1.383 3-3.08 0-1.706-1.346-3.08-3-3.08-1.657 0-3 1.374-3 3.08zM5 12a1 1 0 011-1h11a1 1 0 011 1v11a1 1 0 01-1 1H6a1 1 0 01-1-1V12zm7.152 1.24H8.648V22h2.1v-2.196h1.392c.52 0 .988-.088 1.404-.264.424-.184.78-.424 1.068-.72.296-.304.524-.656.684-1.056.16-.4.24-.82.24-1.26 0-.448-.08-.868-.24-1.26a3.073 3.073 0 00-1.752-1.74 3.539 3.539 0 00-1.392-.264zm-1.404 4.62v-2.724h1.296c.392 0 .716.128.972.384.264.248.396.576.396.984 0 .408-.132.736-.396.984-.256.248-.58.372-.972.372h-1.296z"
  }));
};

var _default = SvgIconTruckPtlDryvan;
exports.default = _default;